import { createSlice } from '@reduxjs/toolkit'

export const AuthenticationReducer = createSlice({
    name: 'authentication',
    initialState: {
        isAuthenticated: false,
    },
    reducers: {
        Authenticate: (state, action) => { state.isAuthenticated = action.payload },
    },
})

// Action creators are generated for each case reducer function
export const { Authenticate } = AuthenticationReducer.actions

export default AuthenticationReducer.reducer